import React, { useEffect, useRef, useState } from "react";
import "./Wallet.css";
import Header from "../../../Layout/Header/Header";
import Footer from "../../../Layout/Footer/Footer";
import Icons from "../../../../../Config/Images";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  addTransactionAPI,
  createWalletAPI,
  getWalletTransactionAPI,
  latestWalletTransactionUrl,
} from "../../../../../Store/Action/walletAction";
import FilterModal from "../CustomModals/FilterModal";
import "react-calendar/dist/Calendar.css"; // Import the default styles
import * as XLSX from "xlsx"; // Import XLSX library
import * as FileSaver from "file-saver"; // Import FileSaver
import jsPDF from "jspdf";
import "jspdf-autotable";
import CustomLoader from "../../../CustomComponents/CustomLoader/CustomLoader";
import { getLoggedInUserDetailsAPI } from "../../../../../Store/Action/UserAction";
import {
  getTransactionStatusAPI,
  getTransactionTypeAPI,
} from "../../../../../Store/Action/rewardPointsAction";
// Helper function to format the time into "hh:mm a" format
// const formatTime = (dateString) => {
//   const date = new Date(dateString);
//   const options = { hour: "2-digit", minute: "2-digit", hour12: true };
//   return date.toLocaleTimeString("en-US", options);
// };

const formatDateTime = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const options = { hour: "2-digit", minute: "2-digit", hour12: true };
  const time = date.toLocaleTimeString("en-US", options);

  return `${day}-${month}-${year} (${time})`;
};
const formatDateForAPI = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const Wallet = () => {
  const dispatch = useDispatch();
  const filterIconRef = useRef(null);

  const [amount, setAmount] = useState(499);
  const [transactions, setTransactions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userData, setUserData] = useState([]);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [selectedDate1, setSelectedDate1] = useState(null);
  const [selectedDate2, setSelectedDate2] = useState(null);
  const [totalBalance, setTotalBalance] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  const [selectedType, setSelectedType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  const [transactionTypes, setTransactionTypes] = useState([]);
  const [transactionStatus, setTransactionStatus] = useState([]);

  // const handleToggleFilter = () => {
  //   setIsFilterOpen((prev) => !prev);
  // };

  const getTransactionTypePayload = React.useCallback(() => {
    if (!selectedType) return undefined;
    return [Number(selectedType)];
  }, [selectedType]);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setUserData(result?.data);
      }),
    );
  }, [dispatch]);

  const handleAmountChange = (event) => {
    const value = event.target.value.replace(/[^0-9.]/g, ""); // Only allow numbers and decimal points
    setAmount(value);
  };

  // Apply filter and fetch transactions
  // const handleApply = () => {
  //   // const params = {
  //   // startDate: selectedDate1 ? selectedDate1.toLocaleDateString("en-CA") : "",
  //   // endDate: selectedDate2 ? selectedDate2.toLocaleDateString("en-CA") : "",
  //   // startDate: selectedDate1 ? formatDateForAPI(selectedDate1) : "",
  //   // endDate: selectedDate2 ? formatDateForAPI(selectedDate2) : "",
  //   // };
  //   const params =
  //     selectedDate1 && selectedDate2
  //       ? {
  //           startDate: selectedDate1.toISOString().split("T")[0],
  //           endDate: selectedDate2.toISOString().split("T")[0],
  //         }
  //       : {};
  //   dispatch(
  //     getWalletTransactionAPI(1000, params, (result) => {
  //       const formattedTransactions = result?.map((transaction) => ({
  //         ...transaction,
  //         time: formatDateTime(transaction.transaction_date), // Format the time/cart
  //       }));
  //       setTransactions(formattedTransactions);
  //     })
  //   );

  //   setIsModalOpen(false); // Close modal after applying filter
  // };
  // const handleApply = () => {
  //   return
  //   const params = {
  //     // startDate: selectedDate1 ? formatDateForAPI(selectedDate1) : "",
  //     // endDate: selectedDate2 ? formatDateForAPI(selectedDate2) : "",
  //   };
  //   if (selectedDate1) params.startDate = formatDateForAPI(selectedDate1);
  //   if (selectedDate2) params.endDate = formatDateForAPI(selectedDate2);
  //   dispatch(
  //     getWalletTransactionAPI(1000, params, (result) => {
  //       const formattedTransactions = result?.map((transaction) => ({
  //         ...transaction,
  //         time: formatDateTime(transaction.transaction_date),
  //       }));
  //       setTransactions(formattedTransactions);
  //     })
  //   );

  //   setIsModalOpen(false);
  // };
  // Wallet component
  // const handleApply = () => {
  //   const params = {};
  //   if (selectedDate1) params.startDate = formatDateForAPI(selectedDate1);
  //   if (selectedDate2) params.endDate = formatDateForAPI(selectedDate2);

  //   dispatch(
  //     getWalletTransactionAPI(1000, params, (result) => {
  //       const formattedTransactions = result?.map((txn) => ({
  //         ...txn,
  //         time: formatDateTime(txn.transaction_date),
  //       }));
  //       setTransactions(formattedTransactions);
  //     })
  //   );
  // };

  const fetchTransactions = React.useCallback(() => {
    setIsLoading(true);

    const params = {
      transactionTypeIds: getTransactionTypePayload(),
      transactionStatusId: selectedStatus || undefined,
    };

    if (selectedDate1) {
      params.startDate = formatDateForAPI(selectedDate1);
    }

    if (selectedDate2) {
      params.endDate = formatDateForAPI(selectedDate2);
    }

    dispatch(
      getWalletTransactionAPI(1000, params, (result) => {
        const formattedTransactions =
          result?.data?.map((transaction) => ({
            ...transaction,
            time: formatDateTime(transaction.transaction_date),
          })) || [];

        setTransactions(formattedTransactions);
        setTotalBalance(result?.total_wallet_amount || 0);
        setIsLoading(false);
      }),
    );
  }, [
    dispatch,
    selectedStatus,
    selectedDate1,
    selectedDate2,
    getTransactionTypePayload,
  ]);

  // const handleApply = (newDate1, newDate2) => {
  //   const startDate = newDate1 || selectedDate1;
  //   const endDate = newDate2 || selectedDate2;

  //   const params = {
  //     transactionTypeIds: getTransactionTypePayload(),
  //     transactionStatusId: selectedStatus || undefined,
  //   };

  //   if (startDate) params.startDate = formatDateForAPI(startDate);
  //   if (endDate) params.endDate = formatDateForAPI(endDate);

  //   dispatch(
  //     getWalletTransactionAPI(1000, params, (result) => {
  //       const formattedTransactions = result?.data.map((transaction) => ({
  //         ...transaction,
  //         time: formatDateTime(transaction.transaction_date),
  //       }));

  //       setTransactions(formattedTransactions);
  //       setIsModalOpen(false); // close modal after apply
  //     }),
  //   );
  // };
  const handleApply = () => {
    setIsModalOpen(false);
    fetchTransactions();
  };

  // Toggle filter modal position
  const handleToggleFilter = () => {
    if (filterIconRef.current) {
      const iconRect = filterIconRef.current.getBoundingClientRect();
      const modalWidth = 370; // Adjust this to the width of your modal
      const availableSpaceRight = window.innerWidth - iconRect.right;

      setModalPosition({
        top: iconRect.bottom + window.scrollY + 20, // Position modal below the icon
        left:
          availableSpaceRight < modalWidth
            ? iconRect.left + window.scrollX - modalWidth // Move modal to the left if not enough space
            : iconRect.right + window.scrollX,
      });
    }
    setIsModalOpen(!isModalOpen); // Toggle modal visibility
  };

  // Fetch transactions on component mount or when filter dates change
  // useEffect(() => {
  //   setIsLoading(true);

  //   dispatch(
  //     getWalletTransactionAPI(
  //       1000,
  //       {
  //         transactionTypeIds: getTransactionTypePayload(), // ✅ FIX
  //         transactionStatusId: selectedStatus || undefined,
  //       },
  //       (result) => {
  //         const formattedTransactions = result?.data.map((transaction) => ({
  //           ...transaction,
  //           time: formatDateTime(transaction.transaction_date), // Format the time
  //         }));
  //         setTransactions(formattedTransactions);
  //         setTotalBalance(result?.total_wallet_amount);
  //         setIsLoading(false);
  //       },
  //     ),
  //   );
  //   // dispatch(
  //   //   latestWalletTransactionUrl({}, (result) => {
  //   //     setTotalBalance(result?.transaction_credit_amount);
  //   //   })
  //   // );
  // }, [dispatch, selectedType, selectedStatus]);

  useEffect(() => {
    fetchTransactions();
  }, [fetchTransactions]);

  //

  // Function to add money to the wallet
  const handleAddMoney = () => {
    if (!amount || parseFloat(amount) <= 0) {
      alert("Please enter a valid amount");
      return;
    }
    // const requestData = {
    //   transaction_amount: parseFloat(amount),
    //   transaction_type_id: 1,
    // };

    // dispatch(
    //   addTransactionAPI(requestData, (result) => {
    //     if (result?.status && result.data) {
    //       window.open(result.data, "_blank");
    //     }
    //   })
    // );
    const reqData = {
      transaction_amount: parseFloat(amount),
    };

    dispatch(
      createWalletAPI(reqData, (result) => {
        if (result?.status && result.razorpayWalletDetails) {
          const orderData = result.razorpayWalletDetails;

          const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY,
            amount: orderData.amount, // Amount in paise
            currency: orderData.currency,
            name: "Zabali Jewelex",
            description: "Add Money to Wallet",
            image: Icons.zabali_header_logo_icon,
            order_id: orderData.id, // 👈 Attach backend-generated Razorpay order_id
            handler: function (response) {
              console.log("Payment Success:", response);

              // ✅ No API call here — backend will verify via webhook/order status
              alert("Payment successful! Money will be added to your wallet.");

              // Refresh wallet balance after success

              fetchTransactions();
            },
            prefill: {
              name: userData?.[0]?.user_first_name,
              email: userData?.[0]?.user_email,
              contact: userData?.[0]?.user_mobile_number,
            },
            theme: {
              color: "#F37254",
            },
          };

          const rzp1 = new window.Razorpay(options);
          rzp1.open();
        } else {
          alert("Unable to initiate payment. Please try again.");
        }
      }),
    );
  };

  const handleDownloadExcel = () => {
    if (!transactions || transactions.length === 0) {
      alert("No transactions available to download.");
      return;
    }

    const doc = new jsPDF();

    // Header Section
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("Transaction Statement", 10, 15);
    doc.setFontSize(12);
    // doc.setFont("NotoSans-Regular", "normal");
    // doc.setFont("times", "normal");
    // doc.text("Apr 01, 2024 - Dec 12, 2024", 10, 23);

    // Get full page width (minus margins)
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 20; // left+right margin
    const usablePageWidth = pageWidth - margin;

    doc.autoTable({
      startY: 30,
      theme: "plain",
      head: [["Sr No.", "Type", "Amount", "Status", "Date"]],
      body: transactions.map((txn, index) => [
        index + 1, // Sr No.
        txn.transaction_type_name,
        `${Number(txn.transaction_amount).toLocaleString("en-IN")}`, // Amount
        txn.transaction_status_name,
        ` ${txn.time}`, // Date + Time
      ]),
      tableWidth: "auto",
      columnStyles: {
        0: { cellWidth: usablePageWidth * 0.1, halign: "right" }, // Sr No.
        1: { cellWidth: usablePageWidth * 0.2, halign: "left" }, // Transaction Type
        2: { cellWidth: usablePageWidth * 0.2, halign: "left" }, // Amount
        3: { cellWidth: usablePageWidth * 0.25, halign: "left" }, // Transaction Status
        4: { cellWidth: usablePageWidth * 0.25, halign: "left" }, // Date
      },

      styles: { fontSize: 10, cellPadding: 4 },
      headStyles: {
        fillColor: [240, 240, 240],
        textColor: 40,
        fontStyle: "bold",
      },
      bodyStyles: { textColor: 50 },
      didParseCell: (data) => {
        // Highlight Amount column if Debit / Credit is in txn.type
        if (data.column.index === 1 && data.row.section === "body") {
          const txn = transactions[data.row.index];
          if (txn.type === "Credit") {
            data.cell.styles.textColor = [0, 128, 0]; // Green
          } else if (txn.type === "Debit") {
            data.cell.styles.textColor = [255, 0, 0]; // Red
          }
        }
      },
    });

    // Footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(10);
    doc.text("Generated by Your App Name", 10, pageHeight - 10);

    // Save PDF
    doc.save("transaction_statement.pdf");
  };

  useEffect(() => {
    dispatch(
      getTransactionTypeAPI({}, (result) => {
        if (result?.status && Array.isArray(result.data)) {
          setTransactionTypes(result.data);
        }
      }),
    );
  }, [dispatch]);
  useEffect(() => {
    dispatch(
      getTransactionStatusAPI({}, (result) => {
        if (result?.status && Array.isArray(result.data)) {
          setTransactionStatus(result.data);
        }
      }),
    );
  }, [dispatch]);

  const getTransactionMeta = (txn) => {
    const amount = parseFloat(txn.transaction_amount) || 0;
    const credit = parseFloat(txn.transaction_wallet_credit_amount) || 0;
    const debit = parseFloat(txn.transaction_wallet_debit_amount) || 0;
    const status = txn.transaction_status_name?.toLowerCase();

    if (status === "pending") {
      return { amount, sign: "", color: "#ff9800" };
    }

    if (debit > 0) {
      return { amount, sign: "-", color: "red" };
    }

    if (credit > 0) {
      return { amount, sign: "+", color: "green" };
    }

    return { amount, sign: "+", color: "green" };
  };

  return (
    <>
      <Header />
      <div className="wallet-main-div">
        <div className="account-header-wallet">
          <p className="ac-header-para">Wallet</p>
        </div>

        <div className="divider" />
        {isLoading ? (
          <>
            <div className="loaderContainer">
              <CustomLoader />
            </div>
          </>
        ) : (
          <div className="wallet-section">
            <div className="wallet-section-left">
              <div className="wallet-section-left-up">
                <p className="balance-para">Total Balance</p>
                <p className="ruppee-para">₹ {totalBalance || 0}</p>
              </div>
              <div className="wallet-section-left-down">
                <p className="add-money-para">Add money to Wallet</p>
                <div className="enter-amount-div">
                  <p className="enter-amount-para">Enter Amount</p>
                  {/* <p className="ruppee-para">₹ 499</p> */}

                  <input
                    type="text"
                    className="amount-input"
                    value={`₹${amount}`}
                    onChange={handleAmountChange} // Handle input changes
                    min="1"
                    style={{ border: "none", outline: "none" }}
                  />
                </div>
                <div className="btns">
                  <button className="add-money-btn" onClick={handleAddMoney}>
                    Add Money{" "}
                  </button>
                  {/* <button className="withdraw-money-btn">Withdraw Money</button> */}
                </div>
              </div>
            </div>
            <div className="wallet-section-right">
              <div className="wallet-transaction-header">
                <p className="transactions-para">Transactions</p>
                <div className="icons-div">
                  <img
                    src={Icons.download_icon}
                    alt="Download"
                    onClick={handleDownloadExcel}
                  />
                  <img
                    ref={filterIconRef}
                    onClick={handleToggleFilter}
                    src={Icons.filter_icon}
                    alt="Filter"
                  />
                </div>
              </div>
              {/* ✅ Filter Section */}
              {isFilterOpen && (
                //chnage class name later filter-section
                <div className="filter-section">
                  <label>
                    Transaction Type
                    <select
                      value={selectedType}
                      onChange={(e) => setSelectedType(e.target.value)}
                    >
                      <option value="">All</option>
                      {transactionTypes?.map((type) => (
                        <option
                          key={type.transaction_type_id}
                          value={type.transaction_type_id}
                        >
                          {type.transaction_type_name}
                        </option>
                      ))}
                    </select>
                  </label>

                  <label>
                    Status
                    <select
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                    >
                      <option value="">All</option>
                      {transactionStatus.map((status) => (
                        <option
                          key={status.transaction_status_id}
                          value={status.transaction_status_id}
                        >
                          {status.transaction_status_name}
                        </option>
                      ))}
                    </select>
                  </label>

                  {/* <button onClick={applyFilters}>Apply</button> */}
                  {/* <button onClick={clearFilters}>Clear</button> */}
                </div>
              )}
              <div className="transaction-info-lists">
                {transactions && transactions.length > 0 ? (
                  transactions.map((transaction, index) => {
                    // const amount =
                    // parseFloat(transaction.transaction_amount) || 0;

                    // const creditAmount =
                    // parseFloat(
                    // transaction.transaction_wallet_credit_amount,
                    // ) || 0;

                    // const debitAmount =
                    // parseFloat(transaction.transaction_wallet_debit_amount) ||
                    // 0;

                    // let isNegative = false;
                    // let color = "green";
                    // let isPending = false;
                    const { amount, sign, color } =
                      getTransactionMeta(transaction);

                    const statusName = transaction.transaction_status_name
                      ? transaction.transaction_status_name.toLowerCase()
                      : "";

                    // if (statusName === "pending") {
                    //   isPending = true;
                    //   color = "#ff9800";
                    // } else if (debitAmount > 0) {
                    //   isNegative = true;
                    //   color = "red";
                    // } else if (creditAmount > 0) {
                    //   isNegative = false;
                    //   color = "green";
                    // }

                    // Badge color based on status
                    let labelBgColor;
                    switch (statusName) {
                      case "paid":
                        labelBgColor = "#4caf50"; // green
                        break;
                      case "pending":
                        labelBgColor = "#ff9800"; // orange
                        break;
                      case "failed":
                        labelBgColor = "#f44336"; // red
                        break;
                      default:
                        labelBgColor = "#9e9e9e"; // fallback gray
                    }
                    return (
                      <div key={index}>
                        <div className="list-info">
                          <div className="left">
                            <p style={{ color: "#9c7726" }}>
                              {transaction?.order_number
                                ? transaction?.order_number
                                : transaction?.transaction_type_name}{" "}
                              {/* <span
                                className="transaction-label"
                                style={{ backgroundColor: labelBgColor }}
                              >
                                {transaction?.transaction_status_name?.toUpperCase()}
                              </span> */}
                            </p>
                            <span>{transaction?.time}</span>
                          </div>
                          <div
                            className="right"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                            }}
                          >
                            {/* <span
                              className="transaction-label"
                              style={{ backgroundColor: labelBgColor }}
                            >
                              {transaction?.transaction_status_name?.toUpperCase()}
                            </span> */}
                            {/* <p style={{ color }}>
                              {isPending ? "" : isNegative ? "-" : "+"} ₹
                              {Math.abs(amount)}
                            </p> */}
                            <p style={{ color }}>
                              {sign} ₹ {Math.abs(amount)}
                            </p>
                          </div>
                        </div>
                        <hr />
                      </div>
                    );
                  })
                ) : (
                  <div className="no-transactions">
                    <p>No transactions found</p>
                  </div>
                )}
              </div>
              {/* 04:18 PM */}
              {/*  */}
            </div>
          </div>
        )}
      </div>

      {isModalOpen && (
        // <FilterModal
        //   closeModal={() => setIsModalOpen(false)}
        //   position={modalPosition}
        //   selectedDate1={selectedDate1}
        //   selectedDate2={selectedDate2}
        //   onDateChange1={handleDateChange1}
        //   onDateChange2={handleDateChange2}
        //   onApply={handleApply}
        // />
        <FilterModal
          closeModal={() => setIsModalOpen(false)}
          position={modalPosition}
          selectedDate1={selectedDate1}
          selectedDate2={selectedDate2}
          setSelectedDate1={setSelectedDate1} // ✅ Pass setter
          setSelectedDate2={setSelectedDate2} // ✅ Pass setter
          onApply={handleApply}
        />
      )}

      <Footer />
    </>
  );
};

export default Wallet;
